import Component from 'ShopUi/models/component';
import EventBus from 'PyzShopUi/scripts/utils/eventBus';
import IEventBusSubscription from 'PyzShopUi/scripts/interfaces/Utils/IEventBusSubscription';
import { EDialogEvents } from 'PyzShopUi/scripts/modules/events/dialogEvent';

export default class ShopSwitcher extends Component {

    private eventBus: EventBus;
    private dialogOpenSubscription: IEventBusSubscription;
    private dialogElement: HTMLElement;

    protected init() {
        const regionLanguageBox: HTMLElement = document.querySelector('#region-language-dialog');
        if (!regionLanguageBox) {
            return;
        }

        this.eventBus = EventBus.getInstance();
        this.dialogElement = regionLanguageBox;

        this.addDialogEventListener();
    }

    private readonly addDialogEventListener = (): void => {
        this.dialogOpenSubscription = this.eventBus.subscribe(EDialogEvents.OPEN_DIALOG, (target: {id: string}): void => {
            const dialogElement: HTMLElement = this.dialogElement;
            if (target !== undefined && target.id === dialogElement.id) {
                this.lazyLoadDialogImages(dialogElement);
                this.updateUrlParams(dialogElement);
            }
        });
    }

    private lazyLoadDialogImages(dialogElement: HTMLElement) {
        const dataSrcElements: NodeListOf<HTMLElement> = dialogElement.querySelectorAll('img[data-src]');
        dataSrcElements.forEach((elementSrc: HTMLImageElement) => elementSrc.src = elementSrc.dataset.src);
    }

    protected readyCallback(): void {
    }

    private updateUrlParams(dialogElement: HTMLElement) {
        const currentUrl = new URL(window.location.href, window.location.origin);
        const dataDomainElements: NodeListOf<HTMLElement> = dialogElement.querySelectorAll('a[data-domain]');
        dataDomainElements.forEach((elementSrc: HTMLLinkElement) => {
            const url: URL =  new URL(elementSrc.dataset.domain);
            url.search = currentUrl.search;
            elementSrc.href = url.toString();
            elementSrc.dataset.domain = url.toString();
        });
    }
}
